import "./Navbar.css";
import LogoImg from "../../assets/Novartis logo.png";
import LogoTwo from "../../assets/Orevan.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { FireBaseContext } from "../../Context/FireBase";
export const Navbar = ({ navAppear }) => {
  const navigate = useNavigate();
  const { currentUserRole } = useContext(FireBaseContext);
  const { pathname } = useLocation();
  const [focusedButton, setFocusedButton] = useState(null);
  const [isAllowedUser, setIsAllowedUser] = useState(null);
  const handleFocus = (id) => {
    setFocusedButton(id);
  };
  useEffect(() => {
    switch (pathname) {
      case "/app":
        setFocusedButton(0);
        break;
      case "/app/events":
        setFocusedButton(1);
        break;
      case "/app/teams":
        setFocusedButton(2);
        break;
      case "/app/AllUsers":
        setFocusedButton(3);
        break;
      case "/app/CreateUser":
        setFocusedButton(4);
        break;
      default:
    }
  }, [pathname]);

  useEffect(() => {
    if (currentUserRole) setIsAllowedUser(currentUserRole.admin); 
    // if (currentUserRole) setIsAllowedUser(true); 
  }, [currentUserRole]);

  const MenuData = [
    {
      icon: "fa-solid fa-house",
      data: "Dashboard",
      nav: "/app",
    },
    {
      icon: "fa-regular fa-calendar",
      data: "Events",
      nav: "events",
    },
    isAllowedUser && {
      icon: "fa-solid fa-users",
      data: "Teams",
      nav: "teams",
    },
    isAllowedUser && {
      icon: "fa-solid fa-users-viewfinder",
      data: "Users",
      nav: "AllUsers",
    },
    isAllowedUser && {
      icon: "fa-solid fa-people-group",
      data: "CreateUser",
      nav: "CreateUser",
    },
    isAllowedUser && {
      icon: "fa-solid fa-envelope",
      data: "Reports",
      nav: "reports",
    },
  ];
  return (


    <nav className={`MainNav ${navAppear && "appearNav"}`}>
      <div className="container  d-flex flex-column  py-5   justify-content-between   align-items-center h-100">
          <div className="h-10">

          <img src={LogoImg} alt="Logo" width={'90%'} style={{objectFit:'contain'}}/>
          </div>
        <div className="h-50 w-100" style={{fontSize: "20px"}}>
          <ul className="d-flex align-items-center w-100  flex-column p-0  gap-3 MainNavList  ">
            {MenuData.map(
              (item, indx) =>
                item && (
                  <li
                    className={` ${
                      indx === focusedButton && "bg-blueColor text-white font-semibold"
                    } gap-2 d-flex align-items-center justify-content-start rounded-3 rounded py-2 px-3 text-black w-100 hover:bg-blueColor mx-1`}
                    key={`${item?.icon}-${indx}`}
                    onClick={() => {
                      navigate(item?.nav);
                    }}
                    onFocus={() => handleFocus(indx)}
                    tabIndex={indx}
                  >
                    <i className={item?.icon}></i>
                    <div className="  d-flex justify-content-start px-3 ">
                      {item?.data}
                    </div>
                  </li>
                )
            )}
          </ul>
        </div>
        <div className=" h-25 d-flex justify-content-center align-items-end" >
          <img src={LogoTwo} alt="SecondLogo" className="w-3/5 lg:w-4/6" style={{objectFit:'contain' , marginRight: "20px"}}/>
        </div>
      </div>
    </nav>
  );
};
